import React from 'react';
import { font } from '../../lib/tokens';

type Variant = 'primary' | 'default' | 'ghost';
type Size = 'md' | 'lg';

type ButtonProps = {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
  className?: string;
  fullWidth?: boolean;
};

// Variant colors and hover states live in `.kc-btn-*` classes (index.css) —
// inline styles would beat the :hover rules, so only layout stays inline.
const base: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  padding: '12px 20px',
  borderRadius: 8,
  fontSize: 14,
  fontWeight: 500,
  textDecoration: 'none',
  fontFamily: font.sans,
  cursor: 'pointer',
};

const sizes: Record<Size, React.CSSProperties> = {
  md: {},
  lg: { padding: '15px 26px', fontSize: 15 },
};

export default function Button({
  children,
  variant = 'default',
  size = 'md',
  href,
  onClick,
  type = 'button',
  className,
  fullWidth,
}: ButtonProps) {
  const style: React.CSSProperties = {
    ...base,
    ...sizes[size],
    ...(fullWidth ? { width: '100%', justifyContent: 'center' } : null),
  };
  const composed = ['kc-btn', `kc-btn-${variant}`, className].filter(Boolean).join(' ');
  if (href) {
    return (
      <a href={href} className={composed} style={style} onClick={onClick}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} className={composed} style={style} onClick={onClick}>
      {children}
    </button>
  );
}
